import { render } from "./BoleteriaLink.vue?vue&type=template&id=77204ba6&scoped=true"
import script from "./BoleteriaLink.vue?vue&type=script&lang=js"
export * from "./BoleteriaLink.vue?vue&type=script&lang=js"

import "./BoleteriaLink.vue?vue&type=style&index=0&id=77204ba6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77204ba6"]])

export default __exports__